import { sniff } from '@/util'
import queryString from 'query-string'

class Env {
  static domainList = {
    'dev': {
      ja: 'jp-sandbox.urboxwin.com',
    },
    'prod': {
      ja: 'jp.urboxwin.com',
    },
  }
  // 获取环境
  static getEnv() {
    const searchObj = queryString.parse(location.search) ?? {}
    // App内直接获取localStorage中的env
    if ( sniff.isUboxApp ) {
      if (window.location.hostname === 'h5.urboxwin.com' || window.location.hostname === 'www.urboxwin.com'){
        localStorage?.setItem('env', 'prod')
        return 'prod'
      }
      return localStorage?.getItem('env') ?? 'prod'
    } else {
      // if (location.hostname === 'localhost') return 'dev'
      if ( searchObj.subenv ) {
        return searchObj.subenv
      } else {
        return localStorage?.getItem('env') ?? 'prod'
      }
    }
  }
  // area 是 en zh ja ar
  static getArea() {
    const searchObj = queryString.parse(location.search) ?? {}
    // App内直接获取localStorage中的env
    if ( sniff.isUboxApp ) {
      return localStorage?.getItem('area') ?? 'ja'
    } else {
      if ( searchObj.area) {
        return searchObj.area
      } else {
        return localStorage?.getItem('area') ?? 'ja'
      }
    }
  }
  // language 是 en zh ja ar
  static getLanguage() {
    const searchObj = queryString.parse(location.search) ?? {}
    // App内直接获取localStorage中的env
    if ( sniff.isUboxApp ) {
      return localStorage?.getItem('language') ?? 'ja'
    } else {
      console.log(searchObj.language)
      if ( searchObj.language) {
        return searchObj.language
      } else {
        console.log(localStorage?.getItem('language'))
        return localStorage?.getItem('language') ?? 'ja'
      }
    }
  }
  static setLanguage(lang = 'ja') {
    localStorage?.setItem('language', lang)
  }
  // 获取接口域名地址
  static getApiBase() {
    const env = Env.getEnv() ? `${Env.getEnv()}`.toLowerCase() : 'prod'
    const area =  Env.getArea() ? `${Env.getArea()}`.toLowerCase() : 'ja'
    return Env.domainList[env][area]
  }
  // 将url中的环境设置到localStorage
  static set() {
    // 清除之前的老的localStorage
    if ( sniff.isUboxApp ) return
    const searchObj = queryString.parse(location.search) ?? {}
    const subEnv = Env.getEnv() ?? 'prod'
    const area = Env.getArea() ?? 'ja'
    const language = Env.getLanguage() ?? 'ja'
    if ( subEnv ) {
      try {
        localStorage?.setItem('env', subEnv)
        localStorage?.setItem('area', area)
        localStorage?.setItem('language', language)
      } catch (error) {
        console.log(error)
      }
    }
  }
}

export default Env